import { Autocomplete, Chip, TextField } from "@mui/material";
import type { GridSlotProps } from "@mui/x-data-grid";

export type Material7AutocompleteProps = GridSlotProps["baseAutocomplete"];

function Material7Autocomplete({
  label,
  placeholder,
  slotProps,
  material,
  ...autocompleteProps
}: Material7AutocompleteProps) {
  return (
    <Autocomplete
      {...autocompleteProps}
      renderValue={(values, getItemProps) =>
        values.map((option, index) => {
          const { key, ...itemProps } = getItemProps({ index });

          return (
            <Chip
              key={key}
              {...itemProps}
              variant="outlined"
              size="small"
              label={autocompleteProps.getOptionLabel?.(option) ?? option}
            />
          );
        })
      }
      renderInput={(params) => {
        const {
          InputLabelProps: autocompleteInputLabelProps,
          InputProps: autocompleteInputProps,
          inputProps: autocompleteHtmlInputProps,
          ...textFieldParams
        } = params;
        const { slotProps: textFieldSlotProps, ...textFieldProps } =
          slotProps?.textField ?? {};

        return (
          <TextField
            {...textFieldParams}
            {...textFieldProps}
            label={label}
            placeholder={placeholder}
            slotProps={{
              htmlInput: {
                ...autocompleteHtmlInputProps,
                ...textFieldSlotProps?.htmlInput,
              },
              input: {
                ...autocompleteInputProps,
                ...textFieldSlotProps?.input,
              },
              inputLabel: {
                shrink: true,
                ...autocompleteInputLabelProps,
                ...textFieldSlotProps?.inputLabel,
              },
            }}
          />
        );
      }}
      {...material}
    />
  );
}

export default Material7Autocomplete;
